import React, { useEffect, useState } from "react";
import SupportTicketsTabs from "./SupportTicketsTabs";
import MUICustomTabs from "../../components/MUICustomTabs";
import { useAdminContext } from "../../Hooks/AdminContext";

function SupportTicket() {
  const { setnavbarTitle } = useAdminContext();
  const [Open, setOpen] = useState("");
  const [tabValue, setTabValue] = useState(1);
  const [userList, setUserList] = useState([]);

  const handleChanges = (event, newValue) => {
    localStorage.removeItem("support_tickets_data");
    setTabValue(newValue);
  };

  const TABS_OPTIONS = [
    {
      title: `All (${Open.all ? Open.all : 0})`,
      component: (
        <SupportTicketsTabs
          tabValue={tabValue}
          setOpen={setOpen}
          valueData={"all"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
    {
      title: `Waiting (${Open.waiting ? Open.waiting : 0})`,
      component: (
        <SupportTicketsTabs
          tabValue={tabValue}
          setOpen={setOpen}
          valueData={"waiting"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
    {
      title: `Answered (${Open.answered ? Open.answered : 0})`,
      component: (
        <SupportTicketsTabs
          tabValue={tabValue}
          setOpen={setOpen}
          valueData={"answered"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
    {
      title: `Closed (${Open.solved ? Open.solved : 0})`,
      component: (
        <SupportTicketsTabs
          setOpen={setOpen}
          tabValue={tabValue}
          valueData={"closed"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
    {
      title: `Trash (${Open.trash ? Open.trash : 0})`,
      component: (
        <SupportTicketsTabs
          tabValue={tabValue}
          setOpen={setOpen}
          valueData={"trash"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
  ];

  useEffect(() => {
    setnavbarTitle("Support Tickets");
  }, []);

  return (
    <div className="container-fluid">
      <div className="row mobile-margin display-flex">
        <div className="col-12">
          <MUICustomTabs
            data={TABS_OPTIONS}
            value={tabValue}
            handleChange={handleChanges}
          />
        </div>
      </div>
    </div>
  );
}

export default SupportTicket;
